# GraphQL mutation to update an email automation

mutation UpdateEmailAutomation($emailAutomation: UpdateEmailAutomationInputFieldInput!) {
    updateEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        emailAutomation {
            id
            emailList {
                id
            }
            entersStage {
                id
            }
            exitsStage {
                id
            }
            sendFromUser {
                id
            }
            delay {
                unit
                timespan
            }
        }
    }
}
